import { render, staticRenderFns } from "./edit-controlling-modal.vue?vue&type=template&id=0bbfa557"
import script from "./edit-controlling-modal.ts?vue&type=script&lang=ts&external"
export * from "./edit-controlling-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-controlling-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbfa557')) {
      api.createRecord('0bbfa557', component.options)
    } else {
      api.reload('0bbfa557', component.options)
    }
    module.hot.accept("./edit-controlling-modal.vue?vue&type=template&id=0bbfa557", function () {
      api.rerender('0bbfa557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/edit-controlling-modal/edit-controlling-modal.vue"
export default component.exports